<!-- 课程管理 添加 -->
<template>
  <div>
    <div class="form_box__group__item">
      <div class="form_box__group__item__title">上课地址:</div>
      <div class="form_box__group__item__content ml-10">
        <el-autocomplete
          v-model="location"
          placeholder="例如：上海市静安区南京西路595号上海棋院"
          class="input__location"
          @select="handleSelectLocation"
          :fetch-suggestions="querySearch"
        ></el-autocomplete>
        <!-- <el-button type="primary" class="ml-2" @click="searchLocation">检查位置信息</el-button> -->
      </div>
      <div class="form_box__group__item__tool"></div>
    </div>
    <div class="form_box__group__item">
      <div class="w-60 ml-2">
        <el-alert title="请确认地图中“蓝色角标”的位置，蓝色角标可以拖拽" type="warning"></el-alert>
      </div>
    </div>

    <div class="map__container">
      <div id="container"></div>
      <div class="dimension">
        <div>经度:{{ lng }}</div>
        <div>纬度:{{ lat }}</div>
        <!-- {{mapAddress}} -->
      </div>
    </div>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "LocationSelector",
  
  mixins: [BaseVue],
    
  data() {
    return {
      location: "", // 地图输入框内容
      lat: 0.0, // 纬度
      lng: 0.0, // 经度
      mapGl: null, // 百度 map
      myGeo: null, // 地址解析器
      mapAddress: "", // 百度逆解析的地址
      mapaddresses: [],
      mapVal: [],
      loading: false
    };
  },
  
  methods: {
    /* 根据地址解析位置信息 */
    searchLocation(suc, fail) {
      let _this = this;
      // 创建地址解析器实例
      if (!this.myGeo) {
        AMap.plugin("AMap.Geocoder", function () {
          _this.myGeo = new AMap.Geocoder({
            city: "021",
          });
        });
      }
      
      // 将地址解析结果显示在地图上,并调整地图视野
      this.myGeo.getLocation(
        this.location,
        function (status, point) {
          if (status == "complete" && point.info == "OK") {
            let location = point.geocodes[0].location;
            _this.lat = location.lat;
            _this.lng = location.lng;
            
            _this.initMarker(_this.lng, _this.lat);
            
            let position = new AMap.LngLat(_this.lng, _this.lat);
            
            _this.myGeo.getAddress(position, (status, result) => {
              if (status == "complete") {
                _this.mapAddress = result.regeocode.formattedAddress;
                
                let faddress = result.regeocode.formattedAddress;
                
                // 装载默认选项
                let objMain = {
                  title: _this.location,
                  address: faddress,
                  lat: position.lat,
                  lng: position.lng,
                };
                _this.mapaddresses.push(objMain);
                
                // 原代码中被注释的推荐选项逻辑
                // // 装载推荐选项
                // let surroundingPos = rs.surroundingPois;
                // for(let i = 0 ; i < surroundingPos.length ; i++){
                //   let bean = surroundingPos[i];
                //   let beanTitle = bean.title;
                //   let beanAddress = bean.address;
                
                //   let obj = {
                //     title : bean.title,
                //     address : bean.address,
                //     lat: bean.point.lat,
                //     lng: bean.point.lng
                //   }
                //   _this.mapaddresses.push(obj);
                // }
                suc();
              }
            });
          } else {
            // alert("您选择地址没有解析到结果!");
            fail("您选择地址没有解析到结果");
          }
        },
        "上海"
      );
    },
    
    initMap() {
      this.mapGl = new AMap.Map("container", {
        zoom: 15,
        center: [121.483, 31.238],
        resizeEnable: true,
      });
    },
    
    showInfoM(e) {
      this.lat = e.lnglat.lat;
      this.lng = e.lnglat.lng;
    },
    
    handleSelectLocation(item) {
      this.lat = item.lat;
      this.lng = item.lng;
      this.updateBMap(this.lng, this.lat);
    },
    
    querySearch(querySearch, cb) {
      if (!querySearch) {
        let ary = new Array();
        cb(ary);
        return;
      }
      
      // 检查是否重复
      if (this.mapaddresses) {
        if (this.mapaddresses.length > 0) {
          // ref
          let eqTitle = false;
          for (let i = 0; i < this.mapaddresses.length; i++) {
            let v = this.mapaddresses[i].title + " (" + this.mapaddresses[i].address + ")";
            let vTitle = this.mapaddresses[i].title;
            if (querySearch === v || querySearch === vTitle) {
              eqTitle = true;
            }
          }
          
          if (eqTitle) {
            cb(this.mapVal);
            return;
          }
        }
        
        this.mapaddresses = [];
        
        this.antiShake(
          this.searchLocation(
            () => {
              let ary = new Array();
              for (let i = 0; i < this.mapaddresses.length; i++) {
                let bean = this.mapaddresses[i];
                let v = bean.title + " (" + bean.address + ")";
                
                let addressAdvObj = {
                  value: v,
                  lat: bean.lat,
                  lng: bean.lng,
                };
                ary.push(addressAdvObj);
              }
              this.mapVal = ary;
              cb(ary);
            },
            (err) => {}
          ),
          2000
        );
      }
    },
    
    antiShake(fun, tim) {
      let timeout = null;
      let _this = this;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fun.call(_this, arguments);
        }, tim);
      };
    },
    
    updateBMap(lng, lat) {
      this.initMarker(lng, lat);
    },
    
    // 初始化标记符号
    initMarker(lng, lat) {
      console.log("init marker", lng, lat);
      
      this.mapGl.clearMap();
      
      // TODO 清除其他的marker
      
      let position = new AMap.LngLat(lng, lat);
      let marker = new AMap.Marker({
        position: position,
        map: this.mapGl,
        draggable: true,
      });
      marker.on("dragging", this.showInfoM);
      this.mapGl.setCenter(position);
      this.mapGl.setZoom(16);
    }
  },
  
  watch: {
    location() {
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("getAdressInfo", addressData);
    }
  },
  
  mounted() {
    this.initMap();
  }
};
</script>

<style scoped lang="scss">
.map__container {
  margin-left: 10px;
  width: 600px;
  height: 400px;
  position: relative;
  .dimension {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(130%);
  }
}
.input__location {
  width: 400px;
}

#container {
  width: 100%;
  height: 100%;
}
</style>

